import React, { forwardRef, useMemo } from 'react';
import styled from 'styled-components';

import { useTicketTable } from './useTicketTable';
import { ITicketTableProps, ITicketTableRef } from '../constants/ticketlist.interface';
import Table from '@components/common/react-table/Table';
import { SortOrder } from '@constants/common.constants';

const TicketTableScroll = styled.div`
    overflow-x: auto;
`;

const TicketTable = forwardRef<ITicketTableRef, ITicketTableProps>((props, ref) => {
    const {
        tickets,
        searchCriteria,
        ticketsCount,
        onRowSelect,
        onCompleteTicketOpen,
        onCompleteVerifyTicketOpen,
        onReassignTicketOpen,
        onCancelTicketOpen,
        onReopenTicketOpen,
        onAutoVerificationOpen,
        isAdvanceSearch,
        viewTicketPermission,
    } = props;

    const { columns, onPagination, onSort, sessionPageInfo } = useTicketTable({
        onCompleteTicketOpen,
        onCompleteVerifyTicketOpen,
        onReassignTicketOpen,
        onCancelTicketOpen,
        onReopenTicketOpen,
        onAutoVerificationOpen,
        isAdvanceSearch,
        viewTicketPermission,
    });

    const visibleColumns = useMemo(() => {
        return columns.filter(column => column.show !== false);
    }, [columns]);

    return (
        <TicketTableScroll>
            <Table
                id="tickets"
                variant="striped"
                columns={visibleColumns}
                data={tickets}
                rowsPerPage={searchCriteria.pageSize}
                totalCount={ticketsCount}
                onPagination={onPagination}
                selectedPage={searchCriteria.startRecord / searchCriteria.pageSize + 1}
                onSortChange={onSort}
                sortById={sessionPageInfo.sortBy}
                sortDesc={sessionPageInfo.sortOrder === SortOrder.DESC}
                allowSort
                manualSortBy
                isDense
                hasPagination
                onRowSelect={onRowSelect}
                isControlledSelection
                ref={ref}
            />
        </TicketTableScroll>
    );
});

TicketTable.displayName = 'TicketTable';
export default TicketTable;
